import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Legacy route — forwards to create feed with modal open. */
const P2PCreateMatch = () => {
  const location = useLocation();
  const fixture = location.state?.fixture;

  if (!fixture) return <Navigate to="/app/p2p/create" replace />;

  return (
    <Navigate
      to="/app/p2p/create"
      replace
      state={{ fixture, league: location.state?.league || null }}
    />
  );
};

export default P2PCreateMatch;
